var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"d-flex w-100 justify-content-between align-items-center"},[_c('h1',{staticClass:"labelBold"},[_vm._v("\n          "+_vm._s(this.$t("qrAccess.activeDrivers.title"))+"\n        ")]),_c('button',{staticClass:"btn-download mr-5",on:{"click":_vm.downloadTable}},[_vm._v(_vm._s(_vm.$t("events.listEvents.donwloadBtn")))])]),_c('router-link',{attrs:{"to":{
          name: 'New Driver',
          params: {
            create: true
          }
        }}},[_c('button',{staticClass:"btn-download mt-2"},[_vm._v("\n          "+_vm._s(_vm.$t("qrAccess.activeDrivers.createBtn"))+"\n        ")])])],1),_c('div',{staticClass:"col-md-12"},[_c('v-server-table',{ref:"driversTable",attrs:{"columns":_vm.table_options.columns,"options":_vm.table_options.options},scopedSlots:_vm._u([{key:"actions",fn:function(props){return [_c('div',{staticClass:"actionsDrivers"},[_c('router-link',{staticClass:"edit-btn",attrs:{"to":{
                name: 'Edit Driver',
                params: {
                  id: props.row.id,
                  controlNumber: props.row.controlNumber,
                  edit: true
                  // edit: props.row
                }
              }}},[_c('i',{staticClass:"far fa-edit"})]),_c('i',{staticClass:"far fa-trash-alt",on:{"click":function($event){return _vm.deleteDriver(props)}}}),_c('router-link',{staticClass:"edit-btn",attrs:{"to":{
                name: 'Driver Details',
                params: {
                  id: props.row.id,
                  controlNumber: props.row.controlNumber,
                  data: props.row,
                  details: true
                }
              }}},[_c('i',{staticClass:"far fa-eye"})])],1)]}}])})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }